module.exports = __webpack_public_path__ + "static/img/null-order-data.a5837f24.png";